<!--
 * @Date: 2020-05-14 09:38:21
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-25 18:49:10
 * @FilePath: /xy-pc/src/components/NavList.vue
 -->
<template>
  <div style="min-width: 650px" class="clearfix">
    <div :class="['nav-item', { active: $route.path === '/' }]" style="padding-left: 28px">
      <router-link to="/" :class="['nav-link', { active: $route.path === '/' }]">首页</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/onlineclass' }]">
      <router-link to="/onlineclass" :class="['nav-link', { active: $route.path === '/onlineclass' }]">在线课程</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/roomclass' }]">
      <router-link to="/roomclass" :class="['nav-link', { active: $route.path === '/roomclass' }]">班级课程</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/classrank' }]">
      <router-link to="/classrank" :class="['nav-link', { active: $route.path === '/classrank' }]">课程排行</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/look' }]">
      <router-link to="/look" :class="['nav-link', { active: $route.path === '/look' }]">证书查询</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/grade' }]">
      <router-link to="/grade" :class="['nav-link', { active: $route.path === '/grade' }]">成绩查询</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/mylibrary' }]">
      <router-link to="/mylibrary" :class="['nav-link', { active: $route.path === '/mylibrary' }]">文库</router-link>
    </div>

    <div v-if="showCenter" :class="['nav-item', { active: $route.path === '/userMessage' }]">
      <router-link to="/userMessage" :class="['nav-link', { active: $route.path === '/userMessage' }]">个人中心</router-link>
    </div>
    <div :class="['nav-item', { active: $route.path === '/mytest' }]">
      <router-link to="/mytest" :class="['nav-link', { active: $route.path === '/mytest' }]">在线考试</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showCenter: {
      default: false,
    },
  },
};
</script>

<style scoped>
.nav-item {
  float: left;
  width: auto;
  line-height: 52px;
  height: 52px;
  font-size: 16px;
  text-align: center;
  padding: 0 15px;
}
.active {
  color: rgba(42, 130, 228, 1);
}
</style>